export default __webpack_public_path__ + "static/media/chambers.25bc8707.svg";